import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import generateJSX from 'src/utils/generateJSX'
import { media } from 'src/styles/styled-components'
import SimpleReactValidator from 'simple-react-validator'
import { prepareContactFormPayload } from 'src/utils'

import ArFormInput from './ArFormInput'
import ArBaseButton from 'src/components/ArBaseButton/ArBaseButton'

const StyledForm = styled.form`
  margin-top: 40px;
  ${ ({ mobileFormStyles }) => mobileFormStyles }
  ${ media.tablet`${ ({ tabletFormStyles }) => tabletFormStyles }` }
  ${ media.desktop`${ ({ desktopFormStyles }) => desktopFormStyles }` }
`

const StyledInput = styled(ArFormInput)`
  margin-bottom: 20px;

  ${ media.tablet`
    margin-bottom: 25px;
  ` }
`

const StyledRules = styled.div`
  color: ${ ({ theme }) => theme.colors.black };
  font-size: 1.2rem;
  font-weight: ${ ({ theme }) => theme.fontWeight.primary.Book };
  letter-spacing: 0.01em;
  line-height: 1.83;
  margin-top: 20px;

  ${ media.tablet`
    line-height: 1.41;
  ` }

  a{
    color: ${ ({ theme }) => theme.colors.flowerViolet };
  }
`

const StyledButtonSend = styled(ArBaseButton)`
  max-width: none;
  width: 100%;

  ${ media.tablet`
    max-width: 250px;
  ` }
`

const StyledFooterWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  width: 100%;

  ${ media.tablet`
    flex-direction: row;
  ` }
`

const StyledFormResponse = styled.div`
  color: ${ p => p.theme.colors[p.error ? 'red' : 'black'] };
  font-family: ${ p => p.theme.font.secondary };
  font-size: 1.2rem;
  margin-top: 20px;
  width: 100%;

  span {
    font-weight: ${ p => p.theme.fontWeight.secondary.Bold };
    line-height: 1.33;
    margin-bottom: 10px;
  }

  ${ media.tablet`
    margin-top: 0;
    width: auto;
    margin-left: 23px;
  ` }
`

class ArFormContact extends React.Component {
  constructor (props) {
    super(props)
    this.validator = new SimpleReactValidator()
    this.state = {
      formData: {},
      formState: {
        sending: false,
        success: false,
        errors: [],
      },

    }
    this.populateFormData()
  }

  static propTypes = {
    form: PropTypes.object,
  }

  handleSubmit (e) {
    e.preventDefault()

    const isNotValid = Object.keys(this.state.formData).find(key => !this.state.formData[key].valid)

    if (isNotValid) {
      window.scrollTo({ top: 0, behavior: 'smooth' })
      this.setState({
        formState: {
          sending: false,
          success: false,
          errors: ['Form is not completed'],
        },
      })
      return
    }

    this.setState({
      formState: {
        sending: true,
        success: false,
        errors: [],
      },
    })

    let xhr = new XMLHttpRequest()
    xhr.addEventListener('readystatechange', e => {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        if (xhr.status === 200) {
          this.setState({
            formState: {
              sending: false,
              success: true,
              errors: [],
            },
          })
        } else {
          const responseMsg = xhr.statusText || 'Something went wrong'
          this.setState({
            formState: {
              sending: true,
              success: false,
              errors: [...this.state.formState.errors, responseMsg],
            },
          })
        }
      }
    })

    xhr.open('POST', process.env.EMAIL_FORM_URL)
    xhr.send(prepareContactFormPayload(this.state.formData))
  }

  populateFormData () {
    this.props.form.fields.forEach(field => {
      this.state.formData[field.name] = {
        valid: false,
        value: '',
      }
    })
  }

  onChange ({ name, value, valid }) {
    this.setState({
      formData: {
        ...this.state.formData,
        [name]: { value, valid },
      },
      formState: {
        sending: false,
        success: false,
        errors: [],
      },
    })
  }

  render () {
    const { form, ...rest } = this.props

    return (
      <StyledForm {...rest}>
        {form.fields.map(({ tag, type, name, label, placeholder, required, rules }, index) =>
          <StyledInput
            key={index}
            tag={tag}
            type={type}
            label={label}
            placeholder={placeholder}
            required={required}
            name={name}
            onChange={this.onChange.bind(this)}
            rules={rules}
          />
        )}

        <StyledRules>{generateJSX(form.rules)}</StyledRules>

        <StyledFooterWrapper>
          <StyledButtonSend
            type="submit"
            onClick={this.handleSubmit.bind(this)}
            label={form.button}
            variant={ this.state.formState.success ? 'green' : 'violet'}
          />
          {this.state.formState.errors.length > 0 && (
            <StyledFormResponse error={true}>
              <span>Oops...</span>
              {this.state.formState.errors.map((err, i) => (<p key={i}>{err}</p>))}
            </StyledFormResponse>
          )}
          {this.state.formState.success && (
            <StyledFormResponse>
              <span>Thank you!</span>
              <p>Your message was sent successfully</p>
            </StyledFormResponse>
          )}
        </StyledFooterWrapper>
      </StyledForm>
    )
  }
}

export default ArFormContact
